export default "__VITE_IMAGE_ASSET__badbf0b6__";